const DEFAULT_LANGUAGES = ['ruby', 'javascript', 'python', 'cli']

export const STORAGE_KEY = 'code-language'

export function preferredCodeLanguage(allowedLanguages = codeLanguages()) {
  const param = normalizedCodeLanguage(
    new URLSearchParams(window.location.search).get('code_language')
  )

  if (validCodeLanguage(param, allowedLanguages)) {
    localStorage.setItem(STORAGE_KEY, param)
    return param
  }

  return storedCodeLanguage(allowedLanguages)
}

export function validCodeLanguage(
  language,
  allowedLanguages = codeLanguages()
) {
  if (!language) return false

  return allowedCodeLanguages(allowedLanguages).includes(language)
}

export function setPreferredCodeLanguage(
  language,
  allowedLanguages = codeLanguages()
) {
  const value = normalizedCodeLanguage(language)
  if (!validCodeLanguage(value, allowedLanguages)) return false

  localStorage.setItem(STORAGE_KEY, value)

  return true
}

function storedCodeLanguage(allowedLanguages) {
  const current = normalizedCodeLanguage(localStorage.getItem(STORAGE_KEY))
  if (validCodeLanguage(current, allowedLanguages)) return current

  return null
}

function normalizedCodeLanguage(language) {
  return language?.trim().toLowerCase() || null
}

function allowedCodeLanguages(languages) {
  return languages
    .map(language => normalizedCodeLanguage(language))
    .filter(Boolean)
}

function codeLanguages() {
  const languages = document.body?.dataset.codeEditorLanguagesValue

  if (!languages) return DEFAULT_LANGUAGES

  const parsed = JSON.parse(languages)

  if (!Array.isArray(parsed)) return DEFAULT_LANGUAGES

  return allowedCodeLanguages(parsed)
}
